import { HttpInterceptorFn } from '@angular/common/http';

// Ensures every request carries the HttpOnly session cookies (X-Access-Token /
// X-Refresh-Token) to and from the backend. Without this, fetch/XHR requests
// made by HttpClient do not include cookies cross-origin by default.
export const withCredentialsInterceptor: HttpInterceptorFn = (req, next) => {
	return next(req.clone({ withCredentials: true }));
};
